import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CreateReportDialog } from "../../components/create-report-dialog";
import { Button } from "@/shared/components/ui/button";

export function RunReportPage() {
  return (
    <>
      <title>Run Report - Researchly</title>
      <div className="flex flex-col gap-6 p-4 sm:p-6">
        <div>
          <h1 className="text-3xl font-semibold tracking-tight">Run report</h1>
          <p className="text-sm text-muted-foreground">
            Choose a template, provide any required inputs, and start a new
            report run.
          </p>
        </div>

        <Card className="max-w-2xl border-border/60">
          <CardHeader>
            <CardTitle>Start from a template</CardTitle>
            <CardDescription>
              This route reuses the current create-report flow until the full
              run-report modal lands.
            </CardDescription>
          </CardHeader>
          <div className="px-6 pb-6">
            <CreateReportDialog
              initialOpen
              trigger={<Button className="rounded-xl px-4">Run report</Button>}
            />
          </div>
        </Card>
      </div>
    </>
  );
}
